import { render, staticRenderFns } from "./MarginHealPopup.vue?vue&type=template&id=923e8dd4&scoped=true&"
import script from "./MarginHealPopup.vue?vue&type=script&lang=js&"
export * from "./MarginHealPopup.vue?vue&type=script&lang=js&"
import style0 from "./MarginHealPopup.vue?vue&type=style&index=0&id=923e8dd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923e8dd4",
  null
  
)

export default component.exports